import React, { Component, PropTypes } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { connect } from 'react-redux';
import { getManipsByZone } from '../reducers/manips';
import { getInsectsRef } from '../reducers/insectsRef';
import { getOtherPestsRef } from '../reducers/otherPestsRef';
import { getCapturesRef } from '../reducers/capturesRef';
import * as actions from '../actions/manips';
import RatColumns from './types/RatColumns';
import RatItem from './types/RatItem';
import InsectColumns from './types/InsectColumns';
import InsectItem from './types/InsectItem';
import DisinfectionColumns from './types/DisinfectionColumns';
import DisinfectionItem from './types/DisinfectionItem';
import OtherPestsColumns from './types/OtherPestsColumns';
import OtherPestsItem from './types/OtherPestsItem';
import AnnexColumns from './types/AnnexColumns';
import AnnexItem from './types/AnnexItem';
import AddManipButton from './AddManipButton';

const mapStateToProps = (state, { zone }) => ({
  manips: getManipsByZone(state, zone.id),
  insectsRef: getInsectsRef(state),
  capturesRef: getCapturesRef(state),
  otherPestsRef: getOtherPestsRef(state),
});

class ZoneItem extends Component {
  constructor(props, context) {
    super(props, context);

    this._type = context.type;
    this._intervention = context.intervention;

    this._renderItem = this._renderItem.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return shallowCompare(this, nextProps);
  }

  _renderColumns() {
    switch (this._type) {
      case 'RAT':
        return <RatColumns />;
      case 'INSECT':
        return <InsectColumns />;
      case 'DISINFECTION':
        return <DisinfectionColumns />;
      case 'OTHER_PESTS':
        return <OtherPestsColumns />;
      case 'ANNEX_1':
        return <AnnexColumns />;
      case 'ANNEX_2':
        return <AnnexColumns />;
      default:
        return null;
    }
  }

  _renderItem(manip) {
    const {
      updateManip,
      deleteManip,
      insectsRef,
      capturesRef,
      otherPestsRef,
      disabled,
    } = this.props;

    let item;
    switch (this._type) {
      case 'RAT':
        item = RatItem;
        break;
      case 'INSECT':
        item = InsectItem;
        break;
      case 'DISINFECTION':
        item = DisinfectionItem;
        break;
      case 'OTHER_PESTS':
        item = OtherPestsItem;
        break;
      case 'ANNEX_1':
        item = AnnexItem;
        break;
      case 'ANNEX_2':
        item = AnnexItem;
        break;
      default:
        return null;
    }

    return React.createElement(item, {
      key: manip.id,
      manip,
      onUpdated: updateManip,
      onDeleted: deleteManip,
      insectsRef,
      capturesRef,
      otherPestsRef,
      disabled,
    });
  }

  render() {
    const { zone, manips, createManip, disabled } = this.props;

    const createManipWithZone = data => createManip(zone.id, data);

    return (
      <table className="ui sortable table">
        <thead>
          <tr className="background states">
            <td colSpan="8">
              <strong>{zone.name}</strong>
              {!disabled && (
                <AddManipButton
                  intervention={this._intervention}
                  zone={zone}
                  onAdded={createManipWithZone}
                />
              )}
              <a
                href={`/pco-manager/zones/${zone.id}/plan`}
                className="ui floated right labeled icon button"
              >
                <i className="icon unhide" />
                Voir le lieu
              </a>
            </td>
          </tr>
          {this._renderColumns()}
        </thead>
        <tbody>{manips.map(this._renderItem)}</tbody>
      </table>
    );
  }
}

ZoneItem.propTypes = {
  zone: PropTypes.object.isRequired,
  manips: PropTypes.array.isRequired,
  createManip: PropTypes.func.isRequired,
  updateManip: PropTypes.func.isRequired,
  deleteManip: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

ZoneItem.contextTypes = {
  intervention: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, actions)(ZoneItem);



// WEBPACK FOOTER //
// ./src/modules/saas/pco/interventions/manipulations/components/ZoneItem.js